import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import FormControl from '../FormControl';
import InputClearIcon from '../InputClearIcon';
import { StyledWrapper, StyledInputWrapper, StyledInput } from './Styles';
import { isFunction, isNumber, stripNonNumeric } from '../../utils/helpers';
function BankAccountInput(_ref) {
  var disabled = _ref.disabled,
    edges = _ref.edges,
    errorMessage = _ref.errorMessage,
    fullWidth = _ref.fullWidth,
    helperText = _ref.helperText,
    helperTextPlacement = _ref.helperTextPlacement,
    hideLabel = _ref.hideLabel,
    label = _ref.label,
    name = _ref.name,
    onChange = _ref.onChange,
    onClear = _ref.onClear,
    required = _ref.required,
    showError = _ref.showError,
    value = _ref.value,
    variant = _ref.variant;
  var bankRef = useRef(null);
  var branchRef = useRef(null);
  var accountRef = useRef(null);
  var suffixRef = useRef(null);
  var _useState = useState(value && value.bank || ''),
    bank = _useState[0],
    setBank = _useState[1];
  var _useState2 = useState(value && value.branch || ''),
    branch = _useState2[0],
    setBranch = _useState2[1];
  var _useState3 = useState(value && value.account || ''),
    account = _useState3[0],
    setAccount = _useState3[1];
  var _useState4 = useState(value && value.suffix || ''),
    suffix = _useState4[0],
    setSuffix = _useState4[1];
  var _useState5 = useState(false),
    focused = _useState5[0],
    setFocused = _useState5[1];
  useEffect(function () {
    setBank(value.bank);
  }, [value.bank]);
  useEffect(function () {
    setBranch(value.branch);
  }, [value.branch]);
  useEffect(function () {
    setAccount(value.account);
  }, [value.account]);
  useEffect(function () {
    setSuffix(value.suffix);
  }, [value.suffix]);
  var valueStr = "" + bank + branch + account + suffix;
  var handleFocus = function handleFocus() {
    setFocused(true);
  };
  var handleBlur = function handleBlur() {
    setFocused(false);
  };
  var handleNextFieldFocus = function handleNextFieldFocus(e) {
    var target = e.target;
    if (target.id === name + "_bank" && branch.length === 0) {
      branchRef.current.focus();
    } else if (target.id === name + "_branch" && account.length === 0) {
      accountRef.current.focus();
    } else if (target.id === name + "_account" && suffix.length === 0) {
      suffixRef.current.focus();
    } else if (target.id === name + "_suffix" && bank.length === 0) {
      bankRef.current.focus();
    }
  };
  var handleClear = function handleClear() {
    setAccount('');
    setBank('');
    setBranch('');
    setSuffix('');
    onClear({
      account: account,
      bank: bank,
      branch: branch,
      suffix: suffix
    });
  };
  var handleBankChange = function handleBankChange(e) {
    var thisValue = stripNonNumeric(e.target.value);
    if (thisValue !== bank) {
      onChange({
        account: account,
        bank: thisValue,
        branch: branch,
        suffix: suffix
      });
      setBank(thisValue);
      if (thisValue && isNumber(thisValue) && thisValue.length === 2) {
        handleNextFieldFocus(e);
      }
    }
  };
  var handleBranchChange = function handleBranchChange(e) {
    var thisValue = stripNonNumeric(e.target.value);
    if (thisValue !== branch) {
      onChange({
        account: account,
        bank: bank,
        branch: thisValue,
        suffix: suffix
      });
      setBranch(thisValue);
      if (thisValue && isNumber(thisValue) && thisValue.length === 4) {
        handleNextFieldFocus(e);
      }
    }
  };
  var handleAccountChange = function handleAccountChange(e) {
    var thisValue = stripNonNumeric(e.target.value);
    if (thisValue !== account) {
      onChange({
        account: thisValue,
        bank: bank,
        branch: branch,
        suffix: suffix
      });
      setAccount(thisValue);
      if (thisValue && isNumber(thisValue) && thisValue.length === 7) {
        handleNextFieldFocus(e);
      }
    }
  };
  var handleSuffixChange = function handleSuffixChange(e) {
    var thisValue = stripNonNumeric(e.target.value);
    if (thisValue !== suffix) {
      onChange({
        account: account,
        bank: bank,
        branch: branch,
        suffix: thisValue
      });
      setSuffix(thisValue);
      if (thisValue && isNumber(thisValue) && thisValue.length === 3) {
        handleNextFieldFocus(e);
      }
    }
  };
  var handlePaste = function handlePaste(e) {
    var text = (e.clipboardData || window.clipboardData).getData('text');
    var sanitizedText = stripNonNumeric(text);
    if (bankRef.current.id === e.target.id && !bankRef.current.value) {
      var values = {
        bank: sanitizedText.slice(0, bankRef.current.maxLength),
        branch: sanitizedText.slice(2, 2 + branchRef.current.maxLength),
        account: sanitizedText.slice(6, 6 + accountRef.current.maxLength),
        suffix: sanitizedText.slice(13, 13 + suffixRef.current.maxLength)
      };
      onChange(values);
      setBank(values.bank);
      setBranch(values.branch);
      setAccount(values.account);
      setSuffix(values.suffix);
    }
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    fullWidth: fullWidth
  }, /*#__PURE__*/React.createElement(FormControl, {
    fullWidth: fullWidth,
    disabled: disabled,
    name: name,
    required: required,
    label: label,
    hideLabel: hideLabel,
    helperText: helperText,
    helperTextPlacement: helperTextPlacement,
    showError: showError,
    errorMessage: errorMessage,
    edges: edges
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: name,
    value: bank + " " + branch + " " + account + " " + suffix
  }), /*#__PURE__*/React.createElement(StyledInputWrapper, {
    disabled: disabled,
    edges: edges,
    focused: focused,
    fullWidth: fullWidth,
    required: required && valueStr.length < 15,
    variant: variant
  }, /*#__PURE__*/React.createElement(StyledInput, {
    disabled: disabled,
    id: name + "_bank",
    fieldType: "bank",
    placeholder: "Bank",
    maxLength: "2",
    ref: bankRef,
    value: bank,
    onChange: handleBankChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onPaste: handlePaste
  }), /*#__PURE__*/React.createElement(StyledInput, {
    disabled: disabled,
    id: name + "_branch",
    fieldType: "branch",
    placeholder: "Branch",
    maxLength: "4",
    ref: branchRef,
    value: branch,
    onChange: handleBranchChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), /*#__PURE__*/React.createElement(StyledInput, {
    disabled: disabled,
    id: name + "_account",
    fieldType: "account",
    placeholder: "Account",
    maxLength: "7",
    ref: accountRef,
    value: account,
    onChange: handleAccountChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  }), /*#__PURE__*/React.createElement(StyledInput, {
    disabled: disabled,
    id: name + "_suffix",
    fieldType: "suffix",
    placeholder: "Suffix",
    maxLength: "3",
    ref: suffixRef,
    value: suffix,
    onChange: handleSuffixChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  }))), isFunction(onClear) && valueStr && /*#__PURE__*/React.createElement(InputClearIcon, {
    onClick: handleClear
  }));
}
BankAccountInput.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,
  /**
   * Make button edges rounded or square
   */
  edges: PropTypes.oneOf(['normal', 'rounded', 'sharp']),
  /**
   * The error message to display if showError === true
   */
  errorMessage: PropTypes.string,
  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,
  /**
   * The helper text content.
   */
  helperText: PropTypes.node,
  /**
   * Make label visible only to screen readers
   */
  hideLabel: PropTypes.bool,
  /**
   * Placed the helper text above or below the input.
   */
  helperTextPlacement: PropTypes.oneOf(['above', 'below']),
  /**
   * The label content.
   */
  label: PropTypes.node,
  /**
   * The input name.
   */
  name: PropTypes.string.isRequired,
  /**
   * Function to handle change event
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Function to handle clear event
   */
  onClear: PropTypes.func,
  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,
  /**
   * Whether or not to display an error message (if there is a message to display).
   */
  showError: PropTypes.bool,
  value: PropTypes.exact({
    bank: PropTypes.string,
    branch: PropTypes.string,
    account: PropTypes.string,
    suffix: PropTypes.string
  }),
  /**
   * How input should look visually
   */
  variant: PropTypes.oneOf(['filled', 'outlined'])
} : {};
BankAccountInput.defaultProps = {
  disabled: false,
  fullWidth: false,
  hideLabel: false,
  helperText: '',
  helperTextPlacement: 'above',
  label: '',
  onClear: undefined,
  required: false,
  showError: false,
  errorMessage: '',
  edges: 'normal',
  value: {
    bank: '',
    branch: '',
    account: '',
    suffix: ''
  },
  variant: 'outlined'
};
export default BankAccountInput;